/// <reference lib="dom" />
import { authProvider } from '@onevision-resources/login';
import { createRoot } from 'react-dom/client';
import { config } from 'src/core/config';
import App from './App';

authProvider.setup({
  cognitoClientId: config.cognitoClientId,
  cognitoUserPoolId: config.cognitoUserPoolId,
  cognitoUserPoolRegion: config.cognitoUserPoolRegion,
  env: config.env,
});

createRoot(document.getElementById('app')!).render(<App />);
